/*
 * @Author: xiaokun
 * @Date: 2020-04-11 17:58:21
 * @LastEditors: xiaokun
 * @LastEditTime: 2020-04-13 10:58:24
 * @Description: 试卷话术库导入，话术库列表
 */
import Vue from 'vue'
import ListTableQuestion from './list-table-question'
import ListTableKeywords from './list-table-keywords'
import ListTableCommodityTags from './list-table-commodity-tags'
// import ListTableParticipationNum from './list-table-participation-num'
// import ListTableNotApprovalNum from './list-table-not-approval-num'

export default {
  type: 'Table', // or Image
  columns: [
    {
      selection: true,
      fixed: true
    },
    {
      prop: 'question',
      label: '问题',
      showOverflowTooltip: false,
      // 自定义组件
      component: ListTableQuestion,
      minWidth: '150',
      fixed: true
    },
    {
      prop: 'keywords',
      label: '关键词',
      showOverflowTooltip: false,
      // 自定义组件
      component: ListTableKeywords,
      minWidth: '320'
    },
    {
      prop: 'commodityTags',
      label: '商品标签',
      showOverflowTooltip: false,
      // 自定义组件
      component: ListTableCommodityTags,
      width: '340'
    },
    {
      prop: 'updateTime',
      label: '最近更新时间',
      width: '160'
    }
  // {
  //   prop: 'showTags',
  //   label: '标签',
  //   // 自定义组件
  //   component: ListTableColumnTag
  // }
  //  {
  //   prop: 'createrPerson',
  //   label: '创建人'
  // }, {
  //   prop: 'createTime',
  //   label: '创建时间'
  // }, {
  //   prop: 'participationNum',
  //   label: '参考人数',
  //   // 自定义组件
  //   component: ListTableParticipationNum
  // }, {
  //   prop: 'notApprovalNum',
  //   label: '未审数',
  //   // 自定义组件
  //   component: ListTableNotApprovalNum
  // }, {
  //   prop: 'action',
  //   label: '操作',
  //   // 自定义组件
  //   component: ListTableAction
  // }
  ]
}
